// This hook determines if Should enable metamask selection or not.
// It should enable metamask when device is desktop.
export const useShouldEnableMetamaskSelection = () => {
    const isMobileBrowser = 'ontouchstart' in document.documentElement;

    return { shouldEnableMetamaskSelection: !isMobileBrowser };
};
